import React from 'react'

import type {SlicePageIntegrationsFragment, IntegrationsFragment} from '@/graphql-types'
import {Integrations} from '@/sections/integrations'

type Props = {
    slice: SlicePageIntegrationsFragment | IntegrationsFragment
}

export const IntegrationsSlice = React.forwardRef(({slice}: Props, ref) => {
    const {
        logo_1,
        logo_1_link,
        logo_2,
        logo_2_link,
        logo_3,
        logo_3_link,
        more_text,
        cta_link,
        cta_text,
        title,
    } = slice.primary

    const logos = [
        ...(logo_1.url && logo_1_link.url ? [{image: logo_1, link: logo_1_link}] : []),
        ...(logo_2.url && logo_2_link.url ? [{image: logo_2, link: logo_2_link}] : []),
        ...(logo_3.url && logo_3_link.url ? [{image: logo_3, link: logo_3_link}] : []),
    ]
    const more = {
        text: more_text,
        link: cta_link,
    }
    const cta = {
        text: cta_text,
        link: cta_link,
    }

    if (!logos.length) {
        return null
    }

    return <Integrations ref={ref} logos={logos} more={more} cta={cta} title={title} />
})
